import { observer } from 'mobx-react-lite'
import type { ContactInfoEditorViewModel } from '@/features/tax-profile/ContactInfoEditorViewModel'
import { TextFieldContainer } from '@/components/inputs/TextFieldContainer'
import { PhysicalAddressEditor } from '@/features/tax-profile/components/PhysicalAddressEditor'

export interface ContactInfoEditorProps {
  vm: ContactInfoEditorViewModel
  testId?: string
}

/**
 * The ContactInfoEditor
 */
export const ContactInfoEditor = observer(function ContactInfoEditor({
  vm,
  testId,
}: ContactInfoEditorProps) {
  return (
    <>
      <TextFieldContainer
        model={vm}
        field="email"
        label="Email address"
        testId={testId ? `${testId}-email-input` : undefined}
      />
      <TextFieldContainer
        model={vm}
        field="phoneNumber"
        label="Phone number"
        testId={testId ? `${testId}-phone-number-input` : undefined}
      />
      <PhysicalAddressEditor vm={vm.physicalAddressVm} testId={testId} />
    </>
  )
})
